/**
 * @ngInject
 */

function login() {

	function LoginController($scope, $auth, $element, $attrs, $mdDialog, flux, actions){
		// console.log("LoginController", $mdDialog);
		this.isAuthenticated = $auth.isAuthenticated();

		this.showLogin = function showLogin(ev) {
		    $mdDialog.show({
				controller: DialogCtrl,
				controllerAs: '$ctrl',
				templateUrl: './angular/views/dialog.tmpl.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:true,
				fullscreen: false,
				locals: {
                    state: 'login',
                    successBtnState: 'frontpage'
                }
		    });
		};

		this.facebookAuth = function facebookAuth(){
	    	// console.log("Login with facebook");
	    	flux.dispatch('AUTHENTICATE_USER', {'type' : 'facebook'});
	    };
	}
	
	return {
		controller: LoginController,
		controllerAs: 'login',
		bindToController: true,
		restrict: "A"
	};
}